import { network } from '@utils'
import { QueryFunction } from '../root.ts'

interface IApixCompanyInfoProps {
  slug: string
}

export interface IApixCompanyInfo {
  einvoicing_address
}

export const fetchApixCustomerInfo: QueryFunction<
  IApixCompanyInfoProps,
  IApixCompanyInfo
> = async ({ slug }) => {
  const url = `/v1/integrations/apix/${slug}/customer_info/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}

export interface IEInvoiceOperator {
  name: string
  code: string
}

interface IEInvoiceOperatorsProps {
  slug: string
}

export const fetchEInvoiceOperators: QueryFunction<
  IEInvoiceOperatorsProps,
  IEInvoiceOperator[]
> = async ({ slug }) => {
  const url = `/v1/business/${slug}/constants/einvoice_operators/`
  const { data } = await network.httpClient.request({ url, method: 'GET' })
  return data
}

export interface IEInvoiceAddress {
  name: string
  business_id: string
  einvoice_address: string
  operator_code: string
}

interface IEInvoiceAddressQueryProps {
  slug: string
  businessId: string
}

export const fetchEInvoiceAddresses: QueryFunction<
  IEInvoiceAddressQueryProps,
  IEInvoiceAddress[]
> = async ({ slug, businessId }) => {
  const url = `/v1/business/${slug}/einvoicing/address_query/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET',
    params: { business_id: businessId }
  })
  return data
}
